export const JUDGE_EVALUATION_METRIC_PREFIX = '$ld:ai:judge:';
